<template>
  <div class="header__container" ref="header">
    <h1
      class="header__item header__item--logo"
    >
      <router-link
        to="/"
        data-mouse
        data-mouse-attractionState="active"
        data-mouse-attractionVal="30"
        data-mouse-magnetism="5"
        data-hover-type="fadeout"
      >
        <Logo />
      </router-link>
    </h1>

    <section class="header__item">
      <FooterAddFace :loaderIsOut="loaderIsOut" />

      <HeaderVoice
        v-for="voice in voices"
        :key="voice.link"
        :data="voice"
        :loaderIsOut="loaderIsOut"
      />

      <ToggleAudio :loaderIsOut="loaderIsOut" />
    </section>
  </div>
</template>

<script>
import gsap from 'gsap';

import Logo from '@/components/Logo';
import ToggleAudio from '@/components/ToggleAudio';
import HeaderVoice from '@/components/HeaderVoice';
import FooterAddFace from '@/components/FooterAddFace';

import { isMobile } from '@/scripts/utils';


export default {
  name: 'HeaderComp',

  props: ['loaderIsOut'],

  watch: {
    loaderIsOut(newVal) {
      if (newVal) this.enterHeader();
    },
  },

  data() {
    return {
      voices: [
        {
          link: 'about',
          namespace: 'about',
          voice: 'About',
        },
      ],

      isMobile,
    };
  },

  components: {
    Logo,
    ToggleAudio,
    HeaderVoice,
    FooterAddFace,
  },

  created() {
    // if (isMobile()) {
    //   this.voices = [
    //     {
    //       link: 'about',
    //       namespace: 'about',
    //       voice: 'About',
    //     },
    //   ];
    // }
  },

  methods: {
    enterHeader() {
      gsap.set(this.$refs.header, {
        autoAlpha: 1,
      });
      gsap.fromTo('.header__item--logo', 0.5, {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
        delay: 0.6,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';

.header__container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  pointer-events: auto;

  .header__voice {
    position: relative;
  }

  h1 {
    margin: 0;
    height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  section {
    position: relative;
    display: inline-block;
    // background-color: transparent;
    // border: 1px solid transparent;
  }

  a {
    pointer-events: auto;
  }

  .header__item--logo a {
    width: 110px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderComp.vue